import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserSproutsEarned = () => {
    const { reportData } = useContext(ReportContext);

    const reportDataEarnedOnly = reportData?.filter((x) => x.sprouts > 0) || [];

    const columns = [
        ...userColumns,
        { field: 'sproutsDatetime', name: 'Date ({tz} time zone)', dataType: 'datetime' },
        { field: 'sproutsSourceCategory', name: 'Category', dataType: 'string' },
        {
            field: 'sproutsSource',
            name: 'Source',
            dataType: 'multiselect',
            styles: { minWidth: '20rem' },
        },
        { field: 'sprouts', name: 'Sprouts Awarded', dataType: 'numeric' },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const filteredDataEarnedOnly = filteredData.filter((row) => row.sprouts > 0);
    // const filteredDataRedeemedOnly = filteredData.filter((row) => row.sprouts < 0);

    // const rolledUpEarnedOnly = dataRollUp(
    //     filteredDataEarnedOnly,
    //     (row) => formatDateToIsoExtDate(row.sproutsDatetime),
    //     {
    //         sumFields: ['sprouts'],
    //     }
    // );
    // const rolledUpRedeemedOnly = dataRollUp(
    //     filteredDataRedeemedOnly,
    //     (row) => formatDateToIsoExtDate(row.sproutsDatetime),
    //     {
    //         sumFields: ['sprouts'],
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Sprouts Earned',
    //         x: rolledUpEarnedOnly.map((x) => x.groupByField),
    //         y: rolledUpEarnedOnly.map((x) => x.sproutsSum),
    //     },
    //     {
    //         name: 'Sprouts Redeemed',
    //         x: rolledUpRedeemedOnly.map((x) => x.groupByField),
    //         y: rolledUpRedeemedOnly.map((x) => x.sproutsSum * -1),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportDataEarnedOnly}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart data={chartData} chartTitle="Sprouts Over Time" />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows all Sprouts earned by users through various
                    activities and achievements. Sprouts are rewards that users can
                    accumulate and later redeem for benefits.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Date">
                    The date when the Sprouts were earned by the user.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Category">
                    The type of activity the user completed which earned them sprouts.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Source">
                    The specific action or resource that resulted in the Sprouts being
                    awarded.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Sprouts Awarded">
                    The number of Sprouts earned from this specific activity.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserSproutsEarned;
